enum DeductibleStatus {
  CarrotManagedDeductible = "CarrotSpecificDeductible",
  ExternalDeductible = "ExternalDeductible",
  NoDeductible = "NoDeductible"
}

export { DeductibleStatus }
